"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.Item = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const react_1 = require("react");
const roman_numbers_1 = require("roman-numbers");
const utils_1 = require("../../utils");
const list_1 = require("../list");
const text_node_1 = require("../text-node");
const alphabetic_1 = require("./alphabetic");
const bulletCandidatesImageDataUrls = [
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAJVJREFUSInt0r0NwjAQQOEvMAk9CVtAzRpp2YBF+BmBBsEEVBSIHRAlCxCKpExkWxRp/KrT2c93ujOZTCYzPkXC3QrLLr7iESNNIx/fYI0zXqgxwy2hwUEWOPTkjyhD8iSiwAq7nvy+O/u7wFf/rgo0EX6QyvCI5iE5Zslv7UJrfLp4iztOITnlm5bamTe44JngZkbkBz74FFKIvkIXAAAAAElFTkSuQmCC',
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAI5JREFUSInt0rENwjAQheEPKFkAmIGELWAhxDysQAljEGp6JGpKQhHTICLHSqQ0/qWTrLPfvbuTyWQymfGZJLwtsQ3nC65DNnJAhWeICvuhim9CwfonKhQx8bSDwQ7LP/lFuOtt8G7JfyfpTal9ReuYeNbB4IE5VpqJX7jjiFNMnPJNC83Oa5xxS9BmRuQDI28dXM/cSMwAAAAASUVORK5CYII=',
];
const numberingFormatters = [
    (i) => i,
    (i) => alphabetic_1.arabToAlphabetic(i - 1),
    (i) => roman_numbers_1.arabToRoman(i).toLowerCase(),
];
const styles = rpdf_renderer_1.StyleSheet.create({
    itemContainer: {
        flexDirection: 'row',
    },
    elementContainer: {
        flex: 1,
    },
    prefixContainer: {
        alignItems: 'flex-end',
    },
});
const getFontSize = (fontSize) => {
    const DEFAULT_FONT_SIZE = 11;
    if (!fontSize)
        return DEFAULT_FONT_SIZE;
    if (typeof fontSize === 'string') {
        const match = fontSize.match(/\d+/);
        return match ? +match[0] : DEFAULT_FONT_SIZE;
    }
    return fontSize;
};
const Item = ({ prefix, style, children, wrap = true }) => {
    /**
     * if the child is a text node, we should override the default orphans value to 0
     * to prevent the line breaking of text node which causes the prefix and the content
     * to render in different lines
     */
    if (children.type === text_node_1.TextNode) {
        children = utils_1.addPropsToReactElement(children, { orphans: 0 });
    }
    return (jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ wrap: wrap, style: Object.assign(Object.assign({}, styles.itemContainer), { marginBottom: getFontSize(style === null || style === void 0 ? void 0 : style.fontSize) }) }, { children: [jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ style: Object.assign(Object.assign({}, styles.prefixContainer), { width: getFontSize(style === null || style === void 0 ? void 0 : style.fontSize) * 2 }) }, { children: [jsx_runtime_1.jsxs(rpdf_renderer_1.Text, Object.assign({ style: {
                            fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
                            fontSize: style === null || style === void 0 ? void 0 : style.fontSize,
                            lineHeight: style === null || style === void 0 ? void 0 : style.lineHeight,
                        } }, { children: [prefix, ' '] }), void 0), jsx_runtime_1.jsx(rpdf_renderer_1.View, { style: {
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            height: 1,
                            width: 1,
                        } }, void 0)] }), void 0), jsx_runtime_1.jsx(rpdf_renderer_1.Text, Object.assign({ style: Object.assign(Object.assign({}, styles.elementContainer), { marginTop: -0.01, width: `calc(100% - ${getFontSize(style === null || style === void 0 ? void 0 : style.fontSize) * 2})` }), orphans: 0, widows: 0 }, { children: children }), void 0)] }), void 0));
};
exports.Item = Item;
const addListItemPrefix = (element, level, type, index, style) => {
    if (!react_1.isValidElement(element)) {
        throw new Error('Invalid react element found in the tree');
    }
    if (type === 'ol' && index) {
        const levelFormatter = (level - 1) % numberingFormatters.length;
        const formattedIndex = numberingFormatters[levelFormatter](index);
        return (jsx_runtime_1.jsx(exports.Item, Object.assign({ prefix: `${formattedIndex}.`, style: {
                fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
                fontSize: style === null || style === void 0 ? void 0 : style.fontSize,
                lineHeight: style === null || style === void 0 ? void 0 : style.lineHeight,
            } }, { children: element }), void 0));
    }
    const candidateIndex = level % bulletCandidatesImageDataUrls.length;
    return (jsx_runtime_1.jsx(exports.Item, Object.assign({ prefix: jsx_runtime_1.jsx(rpdf_renderer_1.Image, { src: bulletCandidatesImageDataUrls[candidateIndex] }, void 0), style: {
            fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
            fontSize: style === null || style === void 0 ? void 0 : style.fontSize,
            lineHeight: style === null || style === void 0 ? void 0 : style.lineHeight,
        } }, { children: element }), void 0));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withListItemPrefix = (children, level, type, index, style) => {
    if (!Array.isArray(children)) {
        return [addListItemPrefix(children, level, type, index, style)];
    }
    return [
        addListItemPrefix(children[0], level, type, index, style),
        ...children.slice(1),
    ];
};
const ListItem = ({ children, index, style }) => {
    const level = react_1.useContext(list_1.LevelContext);
    const type = react_1.useContext(list_1.TypeContext);
    const parentStyle = react_1.useContext(list_1.StyleContext);
    return react_1.createElement(rpdf_renderer_1.View, {}, ...withListItemPrefix(children, level, type, index, Object.assign(Object.assign({}, parentStyle), style)));
};
exports.ListItem = ListItem;
//# sourceMappingURL=list-item.js.map